<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >



    <el-button type="text" @click="dialogVisible_adduser = true"> 添加新用户</el-button><el-button type="text" @click="get_userinfo"> 刷新用户</el-button>


    <el-row>
      <el-col :span="6">

        <el-container style="width: 500px;" >
          <el-header>修改账号</el-header>
          <el-main>
              <el-input style="width: 400px;" placeholder="请输入需要修改的老账号号码" v-model="ddkjss">
              </el-input>
              <br />
              <div style="margin-top: 15px;">
                <el-input placeholder="新的账号名字" v-model="ddkjss2"    style="width: 400px;"    class="input-with-select">
                  <el-button slot="append"  icon="el-icon-finished"  @click="change_id"></el-button>
                </el-input>
              </div>
          </el-main>
        </el-container>
      </el-col>
      <el-col :span="6">
          <el-container style="width: 500px;" >
            <el-header>查询密码</el-header>
            <el-main>
                  <el-input placeholder="需要被查询的账号" v-model="ddkjss3"    style="width: 400px;"    class="input-with-select">
                    <el-button slot="append"  icon="el-icon-search"  @click="chaxunmima"></el-button>
                  </el-input>
                <div style="margin-top: 15px;">
                  <el-input style="width: 400px;" placeholder="查询到的密码结果显示位置" v-model="ddkjss4">
                  </el-input>
                </div>
            </el-main>
          </el-container>
      </el-col>

      <el-col :span="6">
          <el-container style="width: 500px;" >
            <el-header>查询设备在哪几个账号下</el-header>
            <el-main>
                <el-input placeholder="被查询的设备序列号" v-model="ddkjss5"    style="width: 400px;"    class="input-with-select">
                  <el-button slot="append"  icon="el-icon-search"  @click="search_sn"></el-button>
                </el-input>
                <div style=" padding-left: 10px;padding-top:0px;width: 400px">
                  <el-table :data="ddkjss6">
                        <el-table-column
                          prop="id"
                          label="ID"
                          width="100">
                        </el-table-column>
                        <el-table-column
                          prop="user_name"
                          label="用户名"
                          width="150">
                        </el-table-column>
                        <el-table-column
                          prop="user_pass"
                          label="密码"
                          width="150">
                        </el-table-column>
                      </el-table>
                </div>
            </el-main>
          </el-container>
      </el-col>
    </el-row>



    <el-dialog title="添加用户" :visible.sync="dialogVisible_adduser">

          <el-input
            placeholder="用户名"
            v-model="addusername"
            clearable>
          </el-input>
          <el-input
            placeholder="密码"
            v-model="addpasswd"
            clearable>
          </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_adduser = false">取 消</el-button>
        <el-button type="primary" @click="_admin_adduser">确 定</el-button>
      </span>
    </el-dialog>
    <el-table
        :data="userData"
        style="width: 900px">
          <el-table-column
            prop="id"
            label="ID"
            width="60">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="用户名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="昵称"
            width="180" >
        </el-table-column>
        <el-table-column
            prop="user_type"
            label="用户类型">
        </el-table-column>
        <el-table-column
            prop="master_id"
            label="账户层级">
            <template slot-scope="props">
               <el-tag type="success"  v-show="props.row.master_id == '-99'" > GM </el-tag>
               <el-tag type="warning"  v-show="props.row.master_id == -1 "  > USER </el-tag>
               <el-tag type="warning"  v-show="props.row.master_id >  0 "  > ZRUSER </el-tag>
            </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="props">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              @click.native.prevent="select_user_device(props.$index, userData)"
            ></el-button>
          <!--  <el-button
              size="mini"
              type="primary"
              icon="el-icon-coordinate"
              @click.native.prevent="select_user_deviceTest(props.$index, userData)"
            >测试token</el-button> -->
          </template>
        </el-table-column>
    </el-table>

    <el-dialog
      :title="zuser_name"
      :visible.sync="dialogVisible"
      :fullscreen="trues"
      width="width:100%;" >
      <div  >
          <el-row>
            <el-tag type="success" v-if="z0 == 0" >当前账户可以不可以创建子账户</el-tag>
            <el-tag type="success" v-if="z0 == 1"  >当前账户可以创建子账户</el-tag>
            <el-button type="success"  size="mini"  v-if="z0 == 0" @click="change_mask(0,true)" >开启子账户权限</el-button>
            <el-button type="danger" size="mini"  v-if="z0 == 1" @click="change_mask(0,false)">关闭子账户权限</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-tag type="success" v-if="z1 == 0" >当前账户不可以添加设备</el-tag>
            <el-tag type="success" v-if="z1 == 1"  >当前账户可以添加设备</el-tag>
            <el-button type="success"  size="mini"  v-if="z1== 0" @click="change_mask(1,true)" >开启添加设备权限</el-button>
            <el-button type="danger"   size="mini"  v-if="z1 == 1" @click="change_mask(1,false)">禁用添加设备权限</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-tag type="success" v-if="z2 == 0" >当前账户不可以上传文件</el-tag>
            <el-tag type="success" v-if="z2 == 1"  >当前账户可以上传文件</el-tag>
            <el-button type="success"  size="mini"  v-if="z2== 0" @click="change_mask(2,true)" >当前账户不可以上传文件</el-button>
            <el-button type="danger"   size="mini"  v-if="z2 == 1" @click="change_mask(2,false)">当前账户可以上传文件</el-button>
          </el-row>
      </div>

      <el-divider> </el-divider>
      <span>用户已注册设备</span>
      <el-table
          :data="userdevice"
          style="width: 100%">
          <el-table-column
            type="index"
            label="index"
            width="60">



          </el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="60">
            </el-table-column>
            <el-table-column
              prop="device_name"
              label="设备名"
              width="180">
            </el-table-column>
            <el-table-column
              prop="device_seed"
              label="设备序列号"
              width="180" >
          </el-table-column>
          <el-table-column
              prop="status"
              label="设备状态">
              <template slot-scope="props">
                <el-tag type="success"  v-show="props.row.status == 1 " > 在线 </el-tag>
                <el-tag type="warning"  v-show="props.row.status == -1 "  > 离线 </el-tag>
                <el-tag type="success"  v-show="props.row.status ==  2 "  > 正在播放 </el-tag>
                <el-tag type="warning"  v-show="props.row.status == -2 "  > 禁用 </el-tag>
              </template>
          </el-table-column>
          <el-table-column
              prop="device_type"
              label="类型">
              <template slot-scope="props">
                <el-input-number v-model="props.row.device_type"  size="mini"  :min="-100" :max="100" ></el-input-number>
              </template>
          </el-table-column>
          <el-table-column
              prop="vol"
              label="音量">
              <!-- <template slot-scope="props">
                <el-input-number v-model="props.row.vol"  size="mini"  :min="-100" :max="100" ></el-input-number>
              </template> -->
          </el-table-column>
          <el-table-column
              prop="iswarning"
              label="B类">
              <template slot-scope="props">
                <el-input-number v-model="props.row.iswarning"  size="mini"  :min="-100" :max="100" ></el-input-number>
              </template>
          </el-table-column>
          <el-table-column
              prop="kind"
              label="K类">
              <template slot-scope="props">
                <el-input-number v-model="props.row.kind"  size="mini"  :min="-100" :max="100" ></el-input-number>
              </template>
          </el-table-column>
 <!--         <el-table-column
              prop="master_id"
              label="Klein">
              <template slot-scope="props">
                 <el-tag type="success"  v-show="props.row.master_id == '-99'" > GM </el-tag>
                 <el-tag type="warning"  v-show="props.row.master_id == -1 "  > USER </el-tag>
                 <el-tag type="warning"  v-show="props.row.master_id >  0 "  > ZRUSER </el-tag>
              </template>
          </el-table-column>  -->
              <el-table-column
                  label="应用保存">
                <template slot-scope="props">
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-grape"
                    @click.native.prevent="change_user_device(props.$index, userdevice)"
                  ></el-button>
                </template>
              </el-table-column>
      </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
    </el-dialog>

  </div>


</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
function insertStr(source, start, newStr) {
	return source.slice(0, start) + newStr + source.slice(start+1)
}
export default {
  data() {
    return {
      loading :false,
      trues:true,
      devkindkind:0,
      id:0,
      token:"",
      dialogVisible:false,
      userData:[],
      userdevice:[],
      ddkjss6:[],
      addpasswd:"",
      addusername:"",
      ddkjss:"",
      ddkjss2:"",
      ddkjss3:"",
      ddkjss4:"",
      ddkjss5:"",
      userid:0,
      zmask:"",
      z0:0,
      z1:0,
      z2:0,
      z3:0,
      z4:0,
      z5:0,
      z6:0,
      z7:0,
      zuser_name:"",
      dialogVisible_adduser:false
    };
  },
  created(){
      this.id     = sessionStorage.getItem("id");
      this.token  = sessionStorage.getItem("token");
      this.get_userinfo();
  },
  methods: {
    search_sn(){
        if(this.ddkjss5.length!=32){
          this.$notify.success({
            title: "Info",
            message: "输入不正常",
            showClose: true
          });
          return;
        }
        let data = new FormData();
        data.append("id",          this.id );
        data.append("token",       this.token );
        data.append("ddkjss5",      this.ddkjss5 );
        axios.post("user/fnckukei/search_sn", data )
        .then(
          function(res) {
             if(res.data.res){
              this.ddkjss6 = res.data.backdata;
             }else{
               this.$notify.success({
                 title: "Info",
                 message: "查询失败",
                 showClose: true
               });
             }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    chaxunmima(){
      if(this.ddkjss3.length<5){
        this.$notify.success({
          title: "Info",
          message: "输入不正常",
          showClose: true
        });
        return;
      }
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("ddkjss3",      this.ddkjss3 );
      axios.post("user/fnckukei/edit_chaxunmima", data )
      .then(
        function(res) {
           if(res.data.res){
            this.ddkjss4 = res.data.backdata;
           }else{
             this.$notify.success({
               title: "Info",
               message: "修改失败",
               showClose: true
             });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    change_id(){
      console.log(this.ddkjss);
      console.log(this.ddkjss2);
      let data = new FormData();
      if(this.ddkjss.length<5){
        this.$notify.success({
          title: "Info",
          message: "输入不正常",
          showClose: true
        });
        return;
      }
      if(this.ddkjss2.length<5){
        this.$notify.success({
          title: "Info",
          message: "输入不正常",
          showClose: true
        });
        return;
      }
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("ddkjss",      this.ddkjss );
      data.append("ddkjss2",     this.ddkjss2 );
      axios.post("user/fnckukei/edit_changeusername", data )
      .then(
        function(res) {
           if(res.data.res){
            this.get_userinfo();
            this.$notify.success({
              title: "Info",
              message: "修改成功",
              showClose: true
            });
           }else{
             this.$notify.success({
               title: "Info",
               message: "修改失败",
               showClose: true
             });
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    _admin_adduser(){
      if(this.addpasswd.length < 6 ){
        return;
      }
      if(this.addusername.length < 6 ){
        return;
      }
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("username",       this.addusername );
      data.append("passwd",       this.addpasswd );
      axios.post("user/fnckukei/add_user_admin", data )
      .then(
        function(res) {
           console.log(res);
           if(res.data.res == true){
              this.get_userinfo();
              this.select_user_deviceTest( this.addusername , this.addpasswd );
              this.dialogVisible_adduser = false;
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });

    },
    change_mask(index,bl){
      var tthis = this;
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("userid",      this.userid );//deviceid
      data.append("zdex",   index);
      data.append("zcase",     bl  );
      axios.post("user/fnkukei/changezimask", data )
      .then(
        function(res) {
           console.log(res);
           if(res.data.res){
             console.log(res.data.endmask);
             this.zmask = res.data.endmask;
             if(this.zmask.charAt(0)== '1' ){this.z0 = 1;}else{this.z0 = 0;};
             if(this.zmask.charAt(1) == '1' ){this.z1 = 1;}else{this.z1 = 0;};
             if(this.zmask.charAt(2) == '1' ){this.z2 = 1;}else{this.z2 = 0;};
             if(this.zmask.charAt(3) == '1' ){this.z3 = 1;}else{this.z3 = 0;};
             if(this.zmask.charAt(4) == '1' ){this.z4 = 1;}else{this.z4 = 0;};
             if(this.zmask.charAt(5) == '1' ){this.z5 = 1;}else{this.z5 = 0;};
             if(this.zmask.charAt(6) == '1' ){this.z6 = 1;}else{this.z6 = 0;};
             if(this.zmask.charAt(7) == '1' ){this.z7 = 1;}else{this.z7 = 0;};
             tthis.$forceUpdate();
           }
           if(res.data.res1){
              console.log(res.data.endmask);
              this.zmask = res.data.endmask;
              if(this.zmask.charAt(0)== '1' ){this.z0 = 1;}else{this.z0 = 0;};
              if(this.zmask.charAt(1) == '1' ){this.z1 = 1;}else{this.z1 = 0;};
              if(this.zmask.charAt(2) == '1' ){this.z2 = 1;}else{this.z2 = 0;};
              if(this.zmask.charAt(3) == '1' ){this.z3 = 1;}else{this.z3 = 0;};
              if(this.zmask.charAt(4) == '1' ){this.z4 = 1;}else{this.z4 = 0;};
              if(this.zmask.charAt(5) == '1' ){this.z5 = 1;}else{this.z5 = 0;};
              if(this.zmask.charAt(6) == '1' ){this.z6 = 1;}else{this.z6 = 0;};
              if(this.zmask.charAt(7) == '1' ){this.z7 = 1;}else{this.z7 = 0;};
              tthis.$forceUpdate();
           }
           this.get_userinfo();

        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    change_user_device(index, table){
      //console.log(index,table[index]);
      //user/fnkukei/getusersdevice
      let data = new FormData();
      data.append("id",          this.id );
      data.append("token",       this.token );
      data.append("userid",      this.userid );//deviceid
      data.append("deviceid",    table[index].id );
      data.append("kind",        table[index].kind );
      data.append("iswarning",   table[index].iswarning );
      data.append("device_type", table[index].device_type );
      axios.post("user/fnkukei/changeuserdevicemode", data )
      .then(
        function(res) {
           if(res.data.res){
              this.user_devicelist();
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
      user_devicelist(){
          let data = new FormData();
          data.append("id", this.id );
          data.append("token", this.token );
          data.append("userid", this.userid );
          axios
          .post("user/fnkukei/getusersdevice", data )
          .then(
            function(res) {
               if(res.data.res){
                 this.userdevice = res.data.data;
                 this.userdevice.forEach((item,index)=>{
                    this.userdevice[index].device_name = Base64.decode(item.device_name);
                 });
                 console.log(this.userdevice);
               }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });

      }
    ,
    select_user_deviceTest(username, passwd){
      this.dialogVisible  = true;
      let data = new FormData();
      data.append("username", username);
      data.append("passwd", passwd );
      axios
      .post("user/gtoken", data )
      .then(
        function(res) {
           if(res.data.res){
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    select_user_device(index, table){
      //console.log(index,table[index]);
      //user/fnkukei/getusersdevice
      this.dialogVisible  = true;
      let data = new FormData();
      data.append("id", this.id);
      data.append("token", this.token);
      data.append("userid", table[index].id);
      this.userid = table[index].id;
      this.zmask = table[index].mask;
      this.zuser_name = table[index].user_name;
      if(this.zmask.charAt(0)== '1' ){this.z0 = 1;}else{this.z0 = 0;};
      if(this.zmask.charAt(1) == '1' ){this.z1 = 1;}else{this.z1 = 0;};
      if(this.zmask.charAt(2) == '1' ){this.z2 = 1;}else{this.z2 = 0;};
      if(this.zmask.charAt(3) == '1' ){this.z3 = 1;}else{this.z3 = 0;};
      if(this.zmask.charAt(4) == '1' ){this.z4 = 1;}else{this.z4 = 0;};
      if(this.zmask.charAt(5) == '1' ){this.z5 = 1;}else{this.z5 = 0;};
      if(this.zmask.charAt(6) == '1' ){this.z6 = 1;}else{this.z6 = 0;};
      if(this.zmask.charAt(7) == '1' ){this.z7 = 1;}else{this.z7 = 0;};
      axios
      .post("user/fnkukei/getusersdevice", data )
      .then(
        function(res) {
           if(res.data.res){
             this.userdevice = res.data.data;

             this.userdevice.forEach((item,index)=>{
               console.log(Base64.decode(item.device_name));
                item.device_name = Base64.decode(item.device_name);
             });
              console.log(this.userdevice);
           }
        }.bind(this)
      )
      .catch(function(res) {
        console.log(res);
      });
    },
    get_userinfo() {
        let data = new FormData();
        data.append("id", this.id);
        data.append("token", this.token);
        axios
        .post("user/fnkukei/getusersinfo", data )
        .then(
          function(res) {
             if(res.data.res){
               this.userData = res.data.data;

             }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/admin_users_Mg.vue